
import { ref, computed, useContext } from '@nuxtjs/composition-api'
import { FLOW_STATUS } from '~/constants/CheckoutFlow';
import useFlow from '@/composable/checkout/config/useFlow';
import useTracking from '~/composable/tracking/useTracking';
import useCheckout from '@/composable/checkout/useCheckout';
import { FLOW_STEP_STATUS } from '@/constants/FlowStepStatus';

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    trackingEvent: {
      type: String,
      default: 'customerTypeClick'
    },
    selectedMenu: {
      type: String,
      default: null
    }
  },
  emits: ['change'],
  setup(props, ctx) {
    const { track } = useTracking()
    const { app, $vuetify } = useContext()
    const contentContainerName = ref([])
    const selected = ref(props.selectedMenu || null)
    const { state } = useCheckout(app)
    const { flowStatus, currentStep, steps } = useFlow(app, state)

    const isStacked = computed(() => {
      return !$vuetify.breakpoint.smAndUp || (props.items.length > 2 && $vuetify.breakpoint.smAndDown)
    })

    const toggleMenu = (value) => {
      selected.value = selected.value === value ? null : value
      ctx.emit('input', selected.value)
      if (selected.value) {
        track('menuChange', {
          label: props.items.find(item => item.value === value).label,
          currentStep,
          trackingEvent: props.trackingEvent,
          trackingStepName: state?.panels[currentStep.value].heading
        })
      }
    }

    const isStepStatusError = computed(() => {
      return steps.value[currentStep.value]?.status === FLOW_STEP_STATUS.ERROR
    })

    const contentContainerId = (item, index) => {
      return 'menu-content-' + item.value + '-' + index
    }
    // menu model is used to keep track of which menu is open
    const menuModel = {}
    // create values for menu model
    props.items.forEach((item, index) => {
      if (item.activatedMenu !== undefined && item.activatedMenu) {
        selected.value = item.value
      }
      contentContainerName.value[index] = contentContainerId(item, index)
      menuModel[item.value] = computed(() => props.items.length === 1 || selected.value === item.value)
      // Auto-open the only fan (e.g. Privatkunde when Erhvervskunde is hidden)
      if (props.items.length === 1) {
        selected.value = item.value
        ctx.emit('input', selected.value)
      }
    })
    return {
      contentContainerId,
      isStepStatusError,
      FLOW_STATUS,
      flowStatus,
      toggleMenu,
      selected,
      menuModel,
      contentContainerName,
      isStacked
    }
  }
}
